import type { PageMapper } from 'config/page-map';
import type { ReactElement } from 'react';
import React from 'react';
import type { PageData } from 'types/page';
import type SiteContext from 'types/site-context';

export interface PageRendererProps {
  readonly page: PageData;
  readonly pageMapper: PageMapper;
  readonly context: SiteContext;
}

function PageRenderer({
  context,
  page,
  pageMapper,
}: PageRendererProps): ReactElement {
  return <>{pageMapper({ page, context })}</>;
}

export default PageRenderer;
